<template lang="pug">
  div(:class='$style.container')
    template(v-if='!$loggedIn')
      app-link(to='/common/NewSubscription' :class='$style.overlay')
        | Subscribe to get access to the Doxpop Dashboard
    div(:class='$loggedIn ? null : $style.placeholder')
      div(:class='$style.header')
        | {{ header }}
      activity-indicator(:class='$style.indicator' v-if='loading')
      div(:class='$style.links' v-else)
        app-link(
          v-for='(opt, index) in options'
          :key='index'
          :tabindex='$loggedIn ? 0 : -1'
          :class='$style.option'
          :style='getOptionStyle(opt)'
          :to='opt.link'
        )
          p(:class='$style.count') {{ opt.displayText || opt.count }}
          p(:class='$style.descrip') {{ opt.text }}
</template>

<script>
import pluralize from 'pluralize'
import l10n from '@/assets/recorder/l10n.js'

import ActivityIndicator from '@/components/activity-indicator'
import AppLink from '@/components/app-link'
import Icon from 'vue-awesome/components/Icon'
import '@/components/icons/md-keyboard-arrow-left'
import '@/components/icons/md-keyboard-arrow-right'

export default {

  name: 'dashboard',

  components: {
    AppLink,
    Icon,
    ActivityIndicator
  },

  props: {
    route: {
      type: String,
      required: true
    }
  },

  data () {
    return {
      loading: false,
      options: []
    }
  },

  created () {
    this.handleCounts()
  },

  computed: {
    header () {
      // return {
      //   'court': 'Court Cases',
      //   'isefs': 'E-Filing',
      //   'recorder': {
      //     'STATE-IN': 'Recorded Documents',
      //     'STATE-MI': 'Register of Deeds'
      //   }[this.$currentLocale],
      //   'register': {
      //     'STATE-IN': 'Recorded Documents',
      //     'STATE-MI': 'Register of Deeds'
      //   }[this.$currentLocale],
      //   'tax_warrant': 'Tax Warrants'
      // }[this.route]
      return {
        'court': 'Court Dashboard',
        'isefs': 'E-Filing Dashboard',
        'recorder': {
          'STATE-IN': 'Documents Dashboard',
          'STATE-MI': 'Register of Deeds'
        }[this.$currentLocale],
        'register': {
          'STATE-IN': 'Documents Dashboard',
          'STATE-MI': 'Register of Deeds'
        }[this.$currentLocale],
        'tax_warrant': 'Tax Warrants Dashboard'
      }[this.route]
    },
    params () {
      if (this.route !== 'isefs') return {}
      let locale = this.$currentLocale
      let efmUser = this.$store.state.user.efmUsers[locale]
      if (!efmUser) {
        return {}
      }
      return {
        efmUserId: efmUser.id
      }
    }
  },

  watch: {
    $loggedIn: function () {
      this.handleCounts()
    }
  },

  methods: {
    l10n (key) {
      return l10n(this)(key)
    },
    pluralizeOptions (options) {
      return options.map(opt => {
        return {
          ...opt,
          text: opt.text.replace('{0}', pluralize(opt.noun, opt.count))
        }
      })
    },

    getOptionStyle (opt) {
      if (!this.$loggedIn) {
        return {
          'pointer-events': 'none',
          'user-select': 'none'
        }
      }
      if (opt.important && opt.count > 0) {
        return 'color: red;'
      }
    },

    getCounts (uri, callback) {
      if (this.loading) return
      this.loading = true
      this.$api.get(uri, { params: this.params }).then((response) => {
        callback(response.data)
        this.loading = false
      }).catch(() => {
        this.loading = false
      })
    },

    setRecorderCounts (data) {
      let display = null
      let sum = 0
      if (this.$loggedIn) {
        let state = this.l10n('terms.abbreviation')
        let sum = (data.saved_documents && Object.keys(data.saved_documents).length)
          ? Object.values(data.saved_documents).reduce((a, b) => a + b)
          : 0
        if (Object.keys(data.saved_documents).length) {
          if (sum === data.saved_documents[state]) {
            display = data.saved_documents[state]
          } else {
            display = `${sum} (${data.saved_documents[state] || 0} ${this.l10n('terms.state')})`
          }
        }
      }
      this.options = this.pluralizeOptions([
        {
          noun: 'Document',
          count: sum || 0,
          displayText: display,
          text: 'Saved {0}',
          link: '/recorder/ViewMyDocuments?userId=' + this.$store.state.user.id + '&folderId=2'
        },
        {
          noun: 'Search',
          count: data.saved_searches || 0,
          text: 'Saved Document {0}',
          link: '/common/ViewSearchList?action=GET-SEARCH-LIST&userId=' + this.$store.state.user.id
        },
        {
          noun: 'Document',
          count: data.purchased || 0,
          text: 'Purchased {0}',
          link: '/recorder/ViewPurchasedDocuments?userId=' + this.$store.state.user.id
        },
        {
          noun: 'Alert',
          count: data.unread_alerts || 0,
          text: 'Unread Document {0}',
          link: '/common/Notifications?search=is:unread&type=DOCUMENT_WATCH'
        },
        {
          noun: 'Notification',
          count: data.unread_watches || 0,
          text: 'Unread Document Search Watch {0}',
          link: '/common/Notifications?search=is:unread&type=DOCUMENT_SEARCH_WATCH'
        }
      ])
    },

    setTaxCounts (data) {
      this.options = this.pluralizeOptions([
        {
          noun: 'Warrant',
          count: data.saved_warrants || 0,
          text: 'Saved Tax {0}',
          link: '/tax_warrant/ViewMyTaxWarrants?userId=' + this.$store.state.user.id
        },
        {
          noun: 'Search',
          count: data.saved_searches || 0,
          text: 'Saved Tax Warrant {0}',
          link: '/common/ViewSearchList?action=GET-SEARCH-LIST&userId=' + this.$store.state.user.id
        },
        {
          noun: 'Alert',
          count: data.unread_alerts || 0,
          text: 'Unread Tax Warrant {0}',
          link: '/common/Notifications?search=is:unread&type=TAX_WARRANT_WATCH'
        },
        {
          noun: 'Notification',
          count: data.unread_watches || 0,
          text: 'Unread Tax Warrant Search Watch {0}',
          link: '/common/Notifications?search=is:unread&type=TAX_WARRANT_SEARCH_WATCH'
        }
      ])
    },

    setCourtCounts (data) {
      this.options = this.pluralizeOptions([
        {
          noun: 'Event',
          text: '{0} Today',
          count: data.events_today || 0,
          link: '/court/Calendar?action=GET-VIEW-MONTH'
        },
        {
          noun: 'Event',
          text: `{0} ${data.events_upcoming_label}`,
          count: data.events_upcoming || 0,
          link: '/court/Calendar?action=GET-VIEW-MONTH'
        },
        {
          noun: 'Case',
          count: data.saved_cases || 0,
          text: 'Saved Court {0}',
          link: '/court/ViewMyCases?userId=' + this.$store.state.user.id
        },
        {
          noun: 'Search',
          count: data.saved_searches || 0,
          text: 'Saved Case {0}',
          link: '/common/ViewSearchList?action=GET-SEARCH-LIST&userId=' + this.$store.state.user.id
        },
        {
          noun: 'Alert',
          count: data.unread_alerts || 0,
          text: 'Unread Case {0}',
          link: '/common/Notifications?search=is:unread&type=CASE_WATCH'
        },
        {
          noun: 'Notification',
          count: data.unread_watches || 0,
          text: 'Unread Case Search Watch {0}',
          link: '/common/Notifications?search=is:unread&type=CASE_SEARCH_WATCH'
        }
      ])
    },

    setIsefsCounts (data) {
      this.options = this.pluralizeOptions([
        {
          noun: 'Notification',
          count: data.rejected || 0,
          text: 'Unread Rejected Filing {0}',
          link: '/common/Notifications?search=is:unread&type=FILING_REJECTION',
          important: true
        },
        {
          noun: 'Notification',
          count: data.accepted || 0,
          text: 'Unread Accepted Filing {0}',
          link: '/common/Notifications?search=is:unread&type=FILING_ACCEPTANCE'
        },
        {
          noun: 'Notification',
          count: data.service || 0,
          text: 'Unread E-Service {0}',
          link: '/common/Notifications?search=is:unread&type=FILING_SERVICE'
        },
        {
          noun: 'Draft',
          count: data.drafts || 0,
          text: 'Pending E-Filing {0}',
          link: '/isefs/MyDrafts'
        },
        {
          noun: 'Template',
          count: data.templates || 0,
          text: 'E-Filing {0}',
          link: '/isefs/MyTemplates'
        }
        /*
        {
          noun: 'Notification',
          count: data.served || 0,
          text: 'Unread Served Filing {0}',
          link: '/common/Notifications?search=is:unread&type=FILING_SERVED'
        }
        */
      ])
    },

    handleCounts () {
      let config = {
        'court': ['court/dashboard', this.setCourtCounts],
        'recorder': ['recorder/dashboard', this.setRecorderCounts],
        'register': ['recorder/dashboard', this.setRecorderCounts],
        'tax_warrant': ['tax-warrant/dashboard', this.setTaxCounts],
        'isefs': ['famde/dashboard/counts', this.setIsefsCounts]
      }[this.route]
      if (!config) return

      if (this.$loggedIn) {
        this.getCounts(config[0], config[1])
      } else {
        config[1]({})
      }
    }

  }

}
</script>
<style lang="scss" module>
@import 'src/assets/styles/colors';

.container {
  position: relative;
}

.count {
  font-weight: bold;
}

.count {
  font-size: large;
}

.count, .descrip, .header {
  margin: 0;
}

.descrip {
  color: #0000EE;
  text-decoration: underline;
}

.option {
  width: 100%;
  cursor: pointer;
  margin: 0.15rem 0;
  text-align: center;
  background: map-deep-get($base-theme, bg, primary, light);
  display: block;
  border: 1px solid map-deep-get($base-theme, bg, primary, dark);
  padding: 5px 0px;
  color: black;
  text-decoration: none;
  &:hover {
    background-color: map-deep-get($base-theme, bg, secondary, light);
    border-color: map-deep-get($base-theme, bg, secondary, dark);
  }
}

.header {
  font-weight: bold;
  display: block;
  margin-bottom: 0.15rem;
  width: 100%;
  color: white;
  background: map-deep-get($base-theme, bg, primary, dark);
  border: 1px solid black;
  padding: 0.25rem;
  text-align: center;
  span {
    text-align: center;
    padding: 5px 0px;
  }
}

.double_header {
  cursor: pointer;
}

.unselected {
  background-color: #9ECCA9;
}

.indicator {
  margin: 2rem 0;
  font-size: 4pt;
}

.placeholder {
  position: relative;
  text-align: center;
  opacity: 0.6;
  filter: grayscale(100%);
}

.overlay {
  font-weight: bold;
  text-align: center;
  background-color: map-deep-get($base-theme, bg, secondary, dark);
  color: white;
  text-decoration: none;
  width: 11rem;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 1;

  &:hover {
    background-color: #79a9e5;
    cursor: pointer;
  }
}

</style>
